/**
 * LoadingState — the one loading treatment for route-level waits.
 *
 * Replaces the bare "Loading…" text nodes that used to sit top-left on an
 * empty page during Firebase auth init (the first paint of every deep
 * link on a slow network). A quiet skeleton that matches the shell.
 */
export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-24" aria-busy="true" aria-label={label}>
      <div className="animate-pulse space-y-6">
        <div className="h-3 w-28 rounded bg-white/[0.06]" />
        <div className="h-10 w-2/5 rounded bg-white/[0.08]" />
        <div className="h-4 w-3/5 rounded bg-white/[0.05]" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-6">
          <div className="h-44 rounded-lg bg-white/[0.05]" />
          <div className="h-44 rounded-lg bg-white/[0.05]" />
          <div className="h-44 rounded-lg bg-white/[0.05] hidden md:block" />
        </div>
      </div>
    </div>
  )
}
